
function BellIcon({ handleToggleOverlay }) {

    return (
        <div onClick={handleToggleOverlay} className="hover:scale-110 transition-all cursor-pointer hover:animate-bell-wiggle">
            <img src="/360-Lernwelt/extras/bike-bell.png" alt="" className="size-16" />

        </div>
    )
}

export default BellIcon
